module.exports = __webpack_public_path__ + "img/ipad-bg.9b9ad792.png";